export let isScrollingDisabledThroughDataAttribute: boolean = false;
export let scrollMarginTop: number = 0;

export default {
    isScrollingDisabledThroughDataAttribute,
    scrollMarginTop
};
